import {
  FETCH_SEARCH_PROPOSAL,
  SELECT_SEARCH_PROPOSAL,
  FETCH_ALL_SEARCH_PROPOSALS,
  UPDATE_PROPOSAL_ACTION,
  LOGOUT_USER,
  RESET_INITIAL_DATA,
} from '../actions/types';
import {
  PROPOSAL_AFIRMATIVE,
  PROPOSAL_PENDING,
} from '../components/proposal_types';

const INITIAL_STATE = {
  singleProposal: {},
  multipleProposals: [],
  unreadProposalsCount: {},
  loaded: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_SEARCH_PROPOSAL:
      let cleaned_proposal = assign_organization(action.payload);
      return { ...state, singleProposal: cleaned_proposal };
    case SELECT_SEARCH_PROPOSAL:
      cleaned_proposal = assign_organization(action.payload);
      return { ...state, singleProposal: cleaned_proposal };
    case FETCH_ALL_SEARCH_PROPOSALS:
      let unreadProposalsBySearchId = {};

      let mappedProposals = action.payload.map(assign_organization);

      const unansweredProposals = mappedProposals.filter((proposal) => {
        return (
          proposal.archived === false &&
          proposal.data_provider_response &&
          proposal.data_provider_response.action === PROPOSAL_AFIRMATIVE &&
          (!proposal.data_buyer_response ||
            proposal.data_buyer_response.action === PROPOSAL_PENDING)
        );
      });
      unansweredProposals.forEach((proposal) => {
        const searchId = proposal.search;
        if (unreadProposalsBySearchId[searchId])
          unreadProposalsBySearchId[searchId] += 1;
        else unreadProposalsBySearchId[searchId] = 1;
      });
      return {
        ...state,
        multipleProposals: mappedProposals,
        unreadProposalsCount: unreadProposalsBySearchId,
        loaded: true,
      };
    case UPDATE_PROPOSAL_ACTION:
      const newProposalState = state.multipleProposals.map((proposal) => {
        if (action.payload.id !== proposal.id) return proposal;
        else {
          return assign_organization(action.payload);
        }
      });

      return {
        ...state,
        multipleProposals: newProposalState,
        singleProposal: { ...action.payload },
      };
    case RESET_INITIAL_DATA:
    case LOGOUT_USER:
      return INITIAL_STATE;
    default:
      return state;
  }

  function assign_organization(proposal) {
    let data_buyer;

    if (
      !proposal.data_buyer_child ||
      proposal.data_buyer_child.display_master_org_details
    )
      data_buyer = proposal.data_buyer_master;
    else data_buyer = proposal.data_buyer_child;

    return { ...proposal, data_buyer };
  }
};
